module.exports = __webpack_public_path__ + "img/things-logo.009c02bb.svg";